export default __webpack_public_path__ + "static/media/wild-magic.c17a752c.jpeg";